import React from 'react'
import { usePutRequest } from '../../../hooks/request'
import { BUILDING_CATEGORY_DETAIL } from '../../../urls'
import BuildingCategoryForm from './BuildingCategoryForm'

export default function BuildingCategoryUpdate({ onCancel, onSuccess, item }) {
    const brandUpdate = usePutRequest({ url: BUILDING_CATEGORY_DETAIL.replace('{id}', item.id) })

    async function onSubmit(data) {
        const { success } = await brandUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Изменить</b>
            </h1>
            <BuildingCategoryForm
                loading={brandUpdate.loading}
                initialValues={item}
                onSubmit={onSubmit}
                onCancel={onCancel} />
        </div>
    )
}
